import { Text } from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { CyclesService } from "../../services/CyclesService";
import { Selector } from "./Selector";

export const CycleSelect = ({
  selectedCycle,
  selectHandler,
  cycles,
  interaction = true,
}) => {
  return (
    <Selector
      id="cycle-selector"
      label={t("cyclesAndGoals.cycle")}
      assistiveText={t("cyclesAndGoals.cycleSelect")}
      selectHandler={selectHandler}
      options={cycles}
      selectedItemId={selectedCycle.id ?? ""}
      interaction={interaction}
    />
  );
};

export const CycleSelectDashboard = ({
  selectHandler,
  cycles,
  selectedCycle,
  loadedCycles,
}) => {
  return loadedCycles ? (
    <Selector
      id="cycle-selector"
      size="small"
      options={cycles.map((cycle) => ({ id: cycle.id, label: cycle.name }))}
      selectHandler={selectHandler}
      selectedItemId={selectedCycle?.id ?? ""}
      label={t("filter.cycle")}
    />
  ) : (
    <Skeleton
      count={1}
      style={{ width: "100%", height: 24, borderRadius: 5 }}
    />
  );
};

export const CycleSelectLite = ({ selectedCycle, selectHandler }) => {
  const [cycleOptions, setCycleOptions] = useState([]);

  useEffect(() => {
    CyclesService.getCycles().then((cycle_list) => {
      cycle_list.unshift({ id: "0", parent: {}, label: "None", name: "None" });
      cycle_list.forEach((cycle) => {
        cycle.label = cycle.name;
      });
      setCycleOptions(cycle_list);
    });
  }, []);

  return (
    <Selector
      id="parent-cycle-selector"
      label={<Text size="small">{t("cyclesAndGoals.parentCycleSelect")}</Text>}
      assistiveText={t("cyclesAndGoals.parentCycleSelectAssistive")}
      selectHandler={selectHandler}
      options={cycleOptions}
      selectedItemId={selectedCycle?.id}
    />
  );
};
